import entitiesReducer from "../lib/entitiesReducer";
import * as actions from "./actions";
import * as mediaCategoriesActions from "../mediaCategories/actions";
import { Record, Map } from "immutable";
import { isApiCall } from "../app/schema";

import Medias from "./medias";

const feature = "medias";

const InitialState = Record({
  medias: new Medias()
});

const START = "_START";
const SUCCESS = "_SUCCESS";
const ERROR = "_ERROR";

const initialState = new InitialState();

function revive() {
  return initialState.merge({});
}

export default function MediasReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return revive(state);

  if (isApiCall(action.type)) {
    if (
      action.payload &&
      action.payload.entities &&
      action.payload.entities.media
    ) {
      state = state.updateIn(["medias", "entities"], map =>
        map.mergeDeep(action.payload.entities.media)
      );
    }
  }

  switch (action.type) {
    case actions.GET_MEDIAS + START: {
      return state.setIn(["medias", "loading"], true);
    }
    case actions.GET_MEDIAS + SUCCESS: {
      state = state.deleteIn(["medias", "entities"]);
      state = state.deleteIn(["medias", "results"]);
      state = state.setIn(
        ["medias", "meta", "all"],
        action.payload.result.meta.all
      );
      state = state.setIn(
        ["medias", "meta", "count"],
        action.payload.result.meta.count
      );
      state = state.updateIn(["medias", "entities"], map =>
        map.mergeDeep(action.payload.entities.media)
      );
      state = state.setIn(["medias", "results"], action.payload.result.medias);
      return state.setIn(["medias", "loading"], false);
    }
    case actions.GET_MEDIAS + ERROR: {
      return state.setIn(["medias", "loading"], false);
    }

    case mediaCategoriesActions.GET_MEDIA_CATEGORY + START: {
      return state.setIn(["medias", "loading"], true);
    }
    case mediaCategoriesActions.GET_MEDIA_CATEGORY + SUCCESS: {
      return state.setIn(["medias", "loading"], false);
    }
    case mediaCategoriesActions.GET_MEDIA_CATEGORY + ERROR: {
      return state.setIn(["medias", "loading"], false);
    }

    case actions.PATCH_MEDIA + START: {
      return state.setIn(["medias", "loading"], true);
    }
    case actions.PATCH_MEDIA + SUCCESS: {
      return state.setIn(["medias", "loading"], false);
    }
    case actions.PATCH_MEDIA + ERROR: {
      return state.setIn(["medias", "loading"], false);
    }

    case mediaCategoriesActions.DELETE_MEDIA_CATEGORY + START: {
      return state.deleteIn(["medias", "entities", action.payload.uid]);
    }

    case actions.SET_IS_EDIT_MEDIA_MODAL_VISIBLE: {
      return state.setIn(
        ["medias", "isEditModalVisible"],
        action.data.isVisble
      );
    }

    case actions.SET_IS_REMOVE_MEDIA_MODAL_VISIBLE: {
      return state.setIn(
        ["medias", "isRemoveModalVisible"],
        action.data.isVisble
      );
    }

    case actions.SELECT_MEDIA_ITEM: {
      return state.setIn(
        ["medias", "selectedMediaItem", action.data.item],
        action.data.item
      );
    }

    case actions.UNSELECT_MEDIA_ITEM: {
      return state.deleteIn(["medias", "selectedMediaItem", action.data.item]);
    }

    case actions.RESET_SELECTED_MEDIA_ITEMS: {
      return state.setIn(["medias", "selectedMediaItem"], new Map([]));
    }

    case mediaCategoriesActions.GET_MEDIA_CATEGORY_MEDIAS + START: {
      state = state.deleteIn(["medias", "results"]);
      return state.setIn(["medias", "loading"], true);
    }
    case mediaCategoriesActions.GET_MEDIA_CATEGORY_MEDIAS + SUCCESS: {
      state = state.setIn(
        ["medias", "meta", "all"],
        action.payload.result.meta.all
      );
      state = state.setIn(
        ["medias", "meta", "count"],
        action.payload.result.meta.count
      );
      state = state.updateIn(["medias", "entities"], map =>
        map.mergeDeep(action.payload.entities.media)
      );
      state = state.setIn(["medias", "results"], action.payload.result.medias);
      return state.setIn(["medias", "loading"], false);
    }
    case mediaCategoriesActions.GET_MEDIA_CATEGORY_MEDIAS + ERROR: {
      return state.setIn(["medias", "loading"], false);
    }
  }

  return entitiesReducer(state, feature, action);
}



// WEBPACK FOOTER //
// ./src/common/media/reducer.js